export default __webpack_public_path__ + "static/media/Etsy_logo 1.5dc83acb.svg";